<template>
    <div class="relative">
        <!-- Meta Tags -->
        <Head>
            <title>Holanda</title>
        </Head>

        <main :key="$page.url" class="">
            <slot/>
        </main>

    </div>
</template>

<script>

export default {
    name: "Layout",
    data() {
        return {
        }
    },
    computed: {
    },
    methods:{
    }
};

</script>

<style>
</style>
